import styled from "styled-components";

/**
 * Container principal do FieldSearch (Mobile)
 * Configura o layout e a posição do componente.
 */
export const FieldSearchContentMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  height: ${({ theme, isVisible }) => (isVisible ? "100vh" : theme.spacing(8))};
  flex-direction: ${({ isVisible }) => (isVisible ? "column" : "row")};
  /* position: ${({ isVisible }) => (isVisible ? "inherit" : "inherit")}; */
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  display: ${({ isVisible }) => (isVisible ? "inherit" : "flow")};
  background: ${({ theme, isVisible }) => (isVisible ? "none" : "none")};
  z-index: ${({ isVisible }) => (isVisible ? 1000 : 0)};
  padding: ${({ theme, isVisible }) =>
    isVisible ? "0" : `0 ${theme.spacing(2)}`};
  align-items: center;
  overflow: hidden;
  width: 100%;
  top: 0;
  left: 0;
`;

/**
 * Campo de busca (Mobile)
 * Organiza os ícones e o campo de entrada.
 */
export const FieldSearchHeaderMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible?: boolean }>`
  height: ${({ theme, isVisible }) =>
    isVisible ? "initial" : theme.spacing(8)};
  display: ${({ isVisible }) => (isVisible ? "flow" : "flex")};
  background-color: ${({ theme, isVisible }) =>
    isVisible ? theme.colors.vividBlue : "transparent"};
  padding: ${({ theme, isVisible }) =>
    isVisible
      ? `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1)}`
      : 0};
  flex-direction: ${({ isVisible }) => (isVisible ? "column" : "row")};
  width: 100%;

  & > button {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  }

  & > svg {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  }

  & svg {
    color: ${({ theme }) => theme.colors.white};

    & path {
      fill: ${({ theme, isVisible }) => (isVisible ? theme.colors.white : "")};
    }
  }

  & input {
    font-family: ${({ theme }) => theme.fonts.primary};
    background-color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.transparent : "inherit"};
    color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.white : theme.colors.darkGray};
    font-size: ${({ theme, isVisible }) =>
      isVisible ? theme.fontSizes.md : theme.fontSizes.sm};
    height: ${({ theme, isVisible }) =>
      isVisible ? theme.spacing(6) : "inherit"};

    &::placeholder {
      color: ${({ theme, isVisible }) =>
        isVisible ? theme.colors.white : theme.colors.darkGray};
    }
  }
`;

/**
 * Campo de busca (Mobile)
 * Organiza os ícones e o campo de entrada.
 */
export const FieldSearchMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible?: boolean }>`
  padding: ${({ theme }) =>
    (isVisible) =>
      isVisible ? `0` : `${theme.spacing(2)} 0`};
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;
  display: flex;
  width: 100%;

  & > svg {
    margin-top: ${({ theme }) => theme.spacing(1)};
    height: ${({ theme }) => theme.spacing(4)};
    width: auto;
  }
`;

/**
 * Dropdown do FieldSearch (Mobile)
 * Configura o dropdown de sugestões com tamanhos e tipos.
 */
export const FieldSearchDropdownMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["type"].includes(prop),
})<{ type: string }>`
  /* padding-top: ${({ theme }) => theme.spacing(1)}; */
  width: 100%;
`;

export const ModalBackground = styled.div`
  background-color: #3636368f;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: hidden;
  flex-direction: column;
  z-index: 1000;
`;
